import React from "react";
import { Icon, Flex, Text, Box } from "@chakra-ui/react";
import BoxCard from "@/components/common/BoxCard";
import {
  Image as ImageIcon,
  Video,
  File,
  Mic,
  Icon as IconType,
} from "react-feather";
import { useTranslation } from "next-i18next";
import { CloudType, Tag } from "@/types/cloud";
import { TagComponent } from "./Tag";

type Props = {
  selectedType: string;
  selectedTag: number;
  tags: Tag[];

  onSelectTag: (tag: number) => void;
  onSelectType: (type: CloudType) => void;
};

const cloudTypes = [
  { type: CloudType.PHOTO, icon: ImageIcon, label: "photos" },
  { type: CloudType.VIDEO, icon: Video, label: "cloud.videos" },
  { type: CloudType.AUDIO, icon: Mic, label: "cloud.audio" },
  { type: CloudType.OTHER, icon: File, label: "cloud.otherFiles" },
];

const CloudFilters = ({
  tags,
  selectedTag,
  selectedType,
  onSelectTag,
  onSelectType,
}: Props): React.ReactElement => {
  const { t } = useTranslation("common");

  return (
    <BoxCard
      w={{ base: "100%", md: "23%" }}
      mr={{ base: 0, md: 6 }}
      mb={{ base: 6, md: 0 }}
    >
      {cloudTypes?.map((cloudType) => (
        <TypeComponent
          onClick={() => onSelectType(cloudType.type)}
          isSelected={selectedType === cloudType.type}
          key={cloudType.type}
          icon={cloudType.icon}
          name={t(cloudType.label)}
        />
      ))}
      {tags?.length > 0 && (
        <Box
          borderTopColor="light.50"
          borderTopWidth="1px"
          mt={4}
          pt={4}
          display={{ base: "flex", md: "block" }}
          whiteSpace={{ base: "nowrap", md: "normal" }}
          overflowX={{ base: "auto", md: "unset" }}
        >
          {tags?.map((tag) => (
            <TagComponent
              onClick={() => onSelectTag(tag.id)}
              isSelected={selectedTag === tag.id}
              key={tag.id}
              tag={tag}
            />
          ))}
        </Box>
      )}
    </BoxCard>
  );
};

type TypeProps = {
  onClick: () => void;
  isSelected: boolean;
  name: string;
  icon: IconType;
};

const TypeComponent = ({ onClick, isSelected, name, icon }: TypeProps) => (
  <Flex
    align="center"
    borderRadius=".375rem"
    px=".75rem"
    py={2}
    mb={2}
    cursor="pointer"
    fontWeight={isSelected && "500"}
    bg={isSelected && "main.800"}
    color={isSelected && "#FFFFFF"}
    _hover={!isSelected && { bg: "light.100" }}
    transitionProperty="all"
    transitionDuration=".3s"
    transitionTimingFunction="cubic-bezier(.4,0,1,1)"
    onClick={onClick}
  >
    <Icon as={icon} mr={2} />
    <Text>{name}</Text>
  </Flex>
);

export default CloudFilters;
